import { Directive } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
} from '@angular/forms';

/**
 * Valida dígitos verificadores de CPF.
 * Mesmo algoritmo do portal CEI Apps (`pessoa-form.component.ts`).
 */
export function validarCpf(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) {
    return null;
  }

  const cpfLimpo = String(value).replace(/\D/g, '');
  if (cpfLimpo.length !== 11) {
    return { cpfInvalid: { message: 'CPF inválido.' } };
  }

  // Sequências com dígito único repetido (ex.: 00000000000) não são CPF válido.
  if (/^(\d)\1{10}$/.test(cpfLimpo)) {
    return { cpfInvalid: { message: 'CPF inválido.' } };
  }

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += Number(cpfLimpo.charAt(i)) * (10 - i);
  }
  let digito = 11 - (soma % 11);
  if (digito === 10 || digito === 11) {
    digito = 0;
  }
  if (digito !== Number(cpfLimpo.charAt(9))) {
    return { cpfInvalid: { message: 'CPF inválido.' } };
  }

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += Number(cpfLimpo.charAt(i)) * (11 - i);
  }
  digito = 11 - (soma % 11);
  if (digito === 10 || digito === 11) {
    digito = 0;
  }
  if (digito !== Number(cpfLimpo.charAt(10))) {
    return { cpfInvalid: { message: 'CPF inválido.' } };
  }

  return null;
}

/** Diretiva de template (`cpf`) para NgModel / cei-input-text no painel admin. */
@Directive({
  selector: '[cpf]',
  standalone: true,
  providers: [
    { provide: NG_VALIDATORS, useExisting: ValidadorCpfDirective, multi: true },
  ],
})
export class ValidadorCpfDirective implements Validator {
  /** Aplica {@link validarCpf} ao controle associado. */
  validate(control: AbstractControl): ValidationErrors | null {
    return validarCpf(control);
  }
}
